import { useCallback } from "react";
import {
	getChangeTooltipTitle,
	hasChangeHoverTooltip,
	hasUpdatedHoverContent,
} from "../writingAssistantUtils";
import { useFixedPopover } from "./useFixedPopover";

function buildReasoningSections(change, includeWhy = true) {
	const sections = [];

	if (hasUpdatedHoverContent(change)) {
		sections.push({
			label: "Previously",
			text: change.oldContent?.trim() || change.oldDisplayMd || "",
		});
	}

	if (includeWhy && change.reasoning?.trim()) {
		sections.push({ label: "Why", text: change.reasoning });
	}

	return sections;
}

export function useChangeReasoningPopover() {
	const { popoverProps, getHoverHandlers } = useFixedPopover();

	const getAnchorHandlers = useCallback(
		(change, { includeWhy = true } = {}) => {
			if (!hasChangeHoverTooltip(change)) {
				return {};
			}

			return getHoverHandlers({
				title: getChangeTooltipTitle(change),
				sections: buildReasoningSections(change, includeWhy),
			});
		},
		[getHoverHandlers]
	);

	const getSkippedHandlers = useCallback(
	(item) =>
		getHoverHandlers({
			title:"",
			sections: [
				{
					label: "",
					text: item.reason,
				},
			],
		}),
	[getHoverHandlers]
);


	return { popoverProps, getAnchorHandlers,getHoverHandlers,getSkippedHandlers };
}
